module.exports = __webpack_public_path__ + "img/californiacrane.3d2e2e6d.webp";